module.exports = __webpack_public_path__ + "img/cheer.1d61c636.svg";